import {QueryResultInfo} from "./QueryResultInfo";
import {POIItemInfos} from "./POIItemInfos";



/// <summary>
/// 结果返回poi类型的信息
/// </summary>
export class  ResultPOITypeInfo  extends QueryResultInfo{

	constructor()
	{
		super();
		this.dataversion = null;
		this.engineversion = null;
		this.landmarkcount = null;
		this.pois = null;
		this.searchversion = null;
	}

	
	/**
		 *返回poi类型的信息 
		 * @param jsonObj
		 * @return 
		 */		
		static  GetResultPOITypeInfo(jsonObj)
		{	
			let poiTypeInfo=null;
			if(jsonObj==null)return poiTypeInfo;
			
			poiTypeInfo=new ResultPOITypeInfo();
			poiTypeInfo.SetResultBasicInfo(jsonObj);
			poiTypeInfo.dataversion = jsonObj.dataversion;
			poiTypeInfo.engineversion = jsonObj.engineversion;
			poiTypeInfo.landmarkcount = jsonObj.landmarkcount;
			poiTypeInfo.pois = POIItemInfos.GetPOIItems(jsonObj.pois);
			poiTypeInfo.searchversion = jsonObj.searchversion;
			
			return poiTypeInfo;
		}

}//end ResultPOITypeInfo

